export const IS_TOGGLE = "IS_TOGGLE";

export const Toggle = (data) => (dispatch) => {
  dispatch({
    type: IS_TOGGLE,
    payload: data,
  });
};